import { HoverCard, LoadingOverlay, ThemeIcon } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import React, { useState } from "react";

const WorkflowPreviewHover = ({ row }) => {
  const [loading, setLoading] = useState(true);
  return (
    <HoverCard position="right">
      <HoverCard.Target>
        <ThemeIcon variant="subtle">
          <IconEye />
        </ThemeIcon>
      </HoverCard.Target>

      <HoverCard.Dropdown style={{ pointerEvents: "none" }}>
        <LoadingOverlay visible={loading} />
        <img
          src={row.image_url}
          width={175}
          height={250}
          onLoad={() => setLoading(false)}
        />
      </HoverCard.Dropdown>
    </HoverCard>
  );
};

export default WorkflowPreviewHover;
